module.exports = __webpack_public_path__ + "resource/img/image001.d9d14eec.png";